import { Region } from "Infrastructure/Api/Api";
import { Resources, type TFunction } from "Translations/Resources";
import { z } from "zod";

const RESOURCES = Resources.Admin.Raffle.Validation;

// Trimmed, so a whitespace-only name or title is empty. Max lengths mirror the BE limits; their
// message comes from the global zod error map.
const rewardSchema = (t: TFunction) =>
  z.object({
    title: z.string().trim().min(1, t(RESOURCES.RewardTitleRequired)).max(200),
    description: z.string().max(2000).optional(),
    // A cleared number input emits 0 or NaN ("not set", sent as null); anything else is a whole number.
    quantity: z
      .union([z.number(), z.nan()])
      .optional()
      .refine(
        (quantity) =>
          quantity === undefined ||
          Number.isNaN(quantity) ||
          (Number.isInteger(quantity) && quantity >= 0),
        t(RESOURCES.RewardQuantityInvalid),
      ),
  });

export const getRaffleRoundSchema = (t: TFunction) =>
  z.object({
    region: z.enum(Region, t(RESOURCES.RegionRequired)),
    name: z.string().trim().min(1, t(RESOURCES.NameRequired)).max(100),
    // Optional in a draft: the BE requires it only at Announce. Nullable: a cleared DateFormInput
    // emits null.
    drawDate: z.string().nullable().optional(),
    rewards: z.array(rewardSchema(t)),
  });

export type RaffleRoundFormData = z.infer<
  ReturnType<typeof getRaffleRoundSchema>
>;
